// What one delivery records on an order (supplier hub PR 3, 16 Oct 2026): the lines that arrive now, whether the
// order closes, and whether anything exceeds what was ordered. Quantities are compared in thousandths, as the
// backbone's receive_delivery does, so 56.736 m² received in two parts closes the line exactly.
export type PlanLine = {line_no: number; variant_id: string | null; description: string; qty: number; unit: string; to_inventory: boolean; for_job_ref: string | null; received_qty: number; remaining_qty: number};

const thousandths = (n: number) => Math.round(n * 1000);


/** Which lines a delivery answers, and whether it closes the order. Exported for the test. */
export function receiptOf(lines: PlanLine[], arriving: Record<number, string>, where: Record<number, string>) {
  const out: {variant_id: string; qty: number; location: string; unit: string; po_line_no: number}[] = [];
  let complete = true, over = false;
  for (const l of lines) {
    const qty = Number(arriving[l.line_no] ?? '0');
    const now = Number.isFinite(qty) && qty > 0 ? Math.round(qty * 1000) / 1000 : 0;
    if (thousandths(l.received_qty) + thousandths(now) > thousandths(l.qty)) over = true;
    if (thousandths(l.received_qty) + thousandths(now) < thousandths(l.qty)) complete = false;
    if (now > 0 && l.variant_id) out.push({variant_id: l.variant_id, qty: now, location: l.to_inventory ? (where[l.line_no] || 'General Storage') : 'General Storage', unit: l.unit, po_line_no: l.line_no});
  }
  return {lines: out, complete, over};
}
